export default {
  siteTitle: 'Eric Janto',
  siteUrl: 'https://www.ericjanto.com',
  description:
    'Welcome to my personal website. This website contains a project showcase, various writings about computer science, and more',
  userTwitter: 'ericjnto',
}
